import { render, staticRenderFns } from "./editarZona.vue?vue&type=template&id=03283a90"
import script from "./editarZona.vue?vue&type=script&lang=js"
export * from "./editarZona.vue?vue&type=script&lang=js"
import style0 from "./editarZona.vue?vue&type=style&index=0&id=03283a90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports